import type { BgpPeer } from '@dash/shared';

interface BgpRowProps {
  peer: BgpPeer;
}

const stateColor: Record<BgpPeer['state'], string> = {
  established: 'bg-[--color-ok] text-black',
  opensent: 'bg-[--color-warn] text-black',
  openconfirm: 'bg-[--color-warn] text-black',
  active: 'bg-[--color-warn] text-black',
  connect: 'bg-[--color-warn] text-black',
  idle: 'bg-[--color-crit] text-white',
  unknown: 'bg-[--color-fg-muted]/30 text-[--color-fg-dim]',
};

export function BgpRow({ peer }: BgpRowProps) {
  return (
    <div className="flex items-center justify-between rounded-lg border border-[--color-border] bg-[--color-card] px-4 py-3 transition-colors hover:bg-[--color-card-hi]">
      <div className="flex items-center gap-3">
        <span className={`inline-block h-2.5 w-2.5 rounded-full ${peer.state === 'established' ? 'bg-[--color-ok] animate-pulse-soft' : peer.state === 'idle' ? 'bg-[--color-crit] animate-pulse-soft' : 'bg-[--color-warn]'}`} />
        <div>
          <div className="font-medium text-[--color-fg]">{peer.description}</div>
          <div className="font-mono text-xs text-[--color-fg-muted]">{peer.peer}</div>
        </div>
      </div>
      <span className={`rounded-md px-2 py-1 text-[10px] font-bold uppercase tracking-wider ${stateColor[peer.state]}`}>
        {peer.state}
      </span>
    </div>
  );
}
